export default "__VITE_ASSET__277aa34c__"